import React from 'react';
import PropTypes from 'prop-types';

import { isArray, get, includes } from 'lodash';
import defaultUnitFilters from 'config/filters';
import { Paragraph } from 'components/core/Typography';
import { Checkbox } from 'components/core/Checkbox';
import Lightning from 'assets/images/search/lightning2.svg';

import './ExpressCheckInBanner.scss';
import { compose, withHandlers } from 'recompose';

export const enhance = compose(
	withHandlers({
		handleOnChange: ({ onFilter, searchParams }) => ({ target }) => {
			const { checked, value, name } = target;
			const params = get(searchParams, name, []);
			onFilter({ [name]: checked ?
				[...params, value] :
				params.filter((param) => param !== value) });
		}
	})
);

export function ExpressCheckInBanner({ searchParams, handleOnChange }) {
	const omiOption =
		defaultUnitFilters.storage.amenities.options.find((option) => option.value === 'hasOnlineMoveins');

	return (
		<div className="express-checkin-banner">
			<div className="express-checkin-banner-icon">
				<img src={Lightning} alt="express-checkin" />
			</div>
			<div className="express-checkin-banner-text">
				<Paragraph last>
					Facilities with the Express Check-In badge allow
					you to complete rental paperwork online before moving in.
				</Paragraph>
				<div className="express-checkin-banner-button">
					<Checkbox
						key={omiOption.value}
						id={`${omiOption.name}-${omiOption.value}`}
						label="View Facilities Offering Express Check-Ins"
						value={omiOption.value}
						name={omiOption.name}
						onChange={handleOnChange}
						segmentLabel={`${omiOption.name}-filter-${omiOption.value}`}
						checked={
							searchParams[omiOption.name] === `${omiOption.value}` ||
							(isArray(searchParams[omiOption.name]) && includes(searchParams[omiOption.name], `${omiOption.value}`))
						}
					/>
				</div>
			</div>
		</div>
	);
}

ExpressCheckInBanner.propTypes = {
	searchParams: PropTypes.object,
	handleOnChange: PropTypes.func
};

export default enhance(ExpressCheckInBanner);
